import {
    Stack
} from '@mui/material';
import Title2Component from '../../components/title/title2Component';
import AboutBanner from './aboutBanner';
import AboutDescription from './aboutDescription';
import { useTranslation } from 'react-i18next';
import OurValues from './ourValues';
import OurTeam from './ourTeam';

const AboutView = () => {
    const {t} = useTranslation();

    return (
        <>
            <Stack
                direction='column'
                justifyContent='center'
                alignItems='center'
                className='navigationSpace'
                pt={{xs: 15, md: 20}}
            >
                <Title2Component 
                    title={t('about.title')} 
                    description=""
                    needWhite
                />

                <AboutBanner />
                
                <AboutDescription />

                <OurValues />

                <OurTeam />
            </Stack>
        </>
    );
}

export default AboutView;